// src/js/widgets/manager-residency-requests/composables/useRequestFilter.ts

import { ref, onMounted } from 'vue';
import type { ApiResponse, FiltersListResponse } from '../types';
import { getApiUrl } from '@/js/utils/getApiUrl';

export function useRequestFilter() {
  const loading = ref(true);
  const error = ref<string | null>(null);
  const filter = {} as FiltersListResponse;

  const loadFilter = async () => {
    try {
      const url = getApiUrl('/api/personal/application/filters/');
      const response = await fetch(url);

      const result = (await response.json()) as ApiResponse<FiltersListResponse>;

      if (!result || typeof result !== 'object' || result.status !== 'success') {
        throw new Error('Некорректный формат ответа от сервера');
      }

      const data = result.msg;

      filter.status = data.status;
      if (Object.prototype.hasOwnProperty.call(data, 'businessArea'))
        filter.businessArea = data.businessArea;
      if (Object.prototype.hasOwnProperty.call(data, 'rentalProperty'))
        filter.rentalProperty = data.rentalProperty;
      if (Object.prototype.hasOwnProperty.call(data, 'cluster')) filter.cluster = data.cluster;
      if (Object.prototype.hasOwnProperty.call(data, 'educationType'))
        filter.educationType = data.educationType;
    } catch (err) {
      error.value = err instanceof Error ? err.message : 'Ошибка загрузки словаря фильтров';
    } finally {
      loading.value = false;
    }
  };

  onMounted(loadFilter);

  return { filter, loading, error };
}
